<template>
  <div class="about">
    <h1>Excursões</h1>
    <v-container grid-list-md>
      <v-toolbar color="transparent" dense flat>
        <v-toolbar-items>
          <v-btn to="/grouptrip" text transparent
            ><v-icon>add</v-icon> Novo</v-btn
          >
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-menu :v-if="$store.getters.isAccounting" offset-y>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text transparent>
                <v-icon>list_alt</v-icon>Relatórios</v-btn
              >
            </template>
            <v-list>
              <v-list-item
                v-for="(item, i) in reports"
                :key="i"
                @click="showReportParameters(i)"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-toolbar>

      <v-layout column>
        <v-flex md12 mt-3>
          <v-card>
            <v-card-title primary-title>
              <v-text-field
                v-model="searchText"
                append-icon="search"
                label="Buscar"
                v-on:keyup.enter="request()"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-pagination
                v-model="pagination.current"
                :total-visible="Math.min(6, pagination.totalPages)"
                :length="pagination.totalPages"
                @input="request()"
                @next="request()"
                @previous="request()"
              ></v-pagination>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              hide-default-footer
              class="elevation-1"
            >
              <v-progress-linear
                slot="progress"
                color="blue"
                indeterminate
              ></v-progress-linear>

              <template slot="no-data">
                <v-alert :value="true" color="warning" icon="warning"
                  >Nenhum registro encontrado :(</v-alert
                >
              </template>

              <template slot="item" slot-scope="props">
                <tr>
                  <td>
                    <v-btn-toggle borderless>
                      <v-btn small text icon :to="`/grouptrip/${props.item.id}`"
                        ><v-icon>edit</v-icon></v-btn
                      >
                      <v-btn
                        small
                        text
                        icon
                        :to="`/grouptrip/${props.item.id}/organize`"
                        ><v-icon>playlist_add_check</v-icon></v-btn
                      >
                      <v-btn
                        small
                        text
                        icon
                        :to="`/grouptrip/${props.item.id}/accounts`"
                        ><v-icon>monetization_on</v-icon></v-btn
                      >
                    </v-btn-toggle>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.departureDate | moment("L") }}</td>
                </tr>
              </template>
            </v-data-table>
            <v-card-actions>
              <span class="caption grey--text font-italic"
                >{{ pagination.totalItems }} registros encontrados</span
              >
              <v-spacer></v-spacer>
              <v-pagination
                v-model="pagination.current"
                :total-visible="Math.min(6, pagination.totalPages)"
                :length="pagination.totalPages"
                @input="request()"
                @next="request()"
                @previous="request()"
              ></v-pagination>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog :value="reportParametersDialog" persistent max-width="30%">
      <v-card>
        <v-card-title class="headline">Período do Relatório</v-card-title>
        <v-layout px-4 pt-4 wrap>
          <v-flex md12>
            <DatePicker
              id="reportParameterStartDate"
              name="reportParameterStartDate"
              label="Início do Período"
              v-model="reportParameters.startDate"
              required
            ></DatePicker>
          </v-flex>
          <v-flex md12>
            <DatePicker
              id="reportParameterEndDate"
              name="reportParameterEndDate"
              label="Fim do Período"
              v-model="reportParameters.endDate"
              required
            ></DatePicker>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-btn color="error" text @click="reportParametersDialog = false"
            >Cancelar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="showReport(reportParameters.reportIndex)"
            >Ver Relatório</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :value="reportDialog" persistent max-width="80%">
      <v-card>
        <v-card-title class="headline">{{ this.reportTitle }}</v-card-title>
        <v-card-text>
          <iframe
            width="100%"
            height="500px"
            :src="this.reportUrl"
            frameborder="0"
          ></iframe>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeReport">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import api from "@/api";
import DatePicker from "@/components/Shared/DatePicker";
export default {
  name: "grouptrip-list",
  components: {
    DatePicker
  },
  data() {
    return {
      searchText: "",
      loading: false,
      pagination: {
        current: 1,
        totalPages: 0,
        totalItems: 0
      },
      items: [],
      headers: [
        {
          text: "",
          value: "id",
          sortable: false,
          width: 180
        },
        {
          text: "Nome",
          value: "name",
          sortable: false
        },
        {
          text: "Data de Saída",
          value: "departureDate",
          sortable: false
        }
      ],
      reportParametersDialog: false,
      reportParameters: {
        reportIndex: 0,
        startDate: null,
        endDate: null
      },
      reportTitle: null,
      reportDialog: false,
      reportUrl: null,
      reports: [
        {
          title: "Bônus",
          url: `/reports/grouptrips/accounting/bonus`
        },
        {
          title: "Comissões",
          url: `/reports/grouptrips/accounting/commission`
        }
      ]
    };
  },
  methods: {
    request() {
      this.loading = true;
      api
        .request(
          "GET",
          `/trips/groupTrips/?pageSize=10&pageIndex=${this.pagination.current -
            1}&searchFor=${encodeURIComponent(this.searchText || "")}`
        )
        .then(response => {
          this.loading = false;
          this.items = response.data.items;
          this.pagination.totalItems = response.data.totalItems;
          this.pagination.totalPages = Math.ceil(
            response.data.totalItems / response.data.currentPageSize
          );
        })
        .catch(() => {
          this.loading = false;
        });
    },
    showReportParameters(reportIndex) {
      this.reportParameters.reportIndex = reportIndex;
      this.reportParameters.startDate = null;
      this.reportParameters.endDate = null;
      this.reportParametersDialog = true;
    },
    showReport(reportIndex) {
      this.reportParametersDialog = false;
      this.reportTitle = this.reports[reportIndex].title;
      var report_url = `${this.reports[reportIndex].url}?startDate=${this.reportParameters.startDate}&endDate=${this.reportParameters.endDate}`;
      api
        .request("GET", report_url, null, {}, "arraybuffer")
        .then(response => {
          this.reportUrl = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );
          this.reportDialog = true;
        })
        .catch(error => {
          this.$refs.loadingStatusCard.fail(error.response.data);
        });
    },
    closeReport() {
      window.URL.revokeObjectURL(this.reportUrl);
      this.reportUrl = null;
      this.reportTitle = null;
      this.reportDialog = false;
    }
  },
  watch: {
    searchText() {
      this.pagination.current = 1;
    }
  },
  mounted() {
    this.search = null;
    this.pagination.current = 1;
    this.request();
  }
};
</script>
